import repositoryHelper from './repositoryHelper';
import anonymousRepositoryHelper from './anonymousRepositoryHelper';

function SystemSettingsRepository() {

  var self = this;
  var resourceBaseUrl = 'api/systemSettings';

  /**
   * Get the URL of the Identity Server logon page for the Portal
   * @return {string}
   */
  self.getAuthenticationSettings = function () {

    var resourceUrl = resourceBaseUrl + '/authenticationSettings';

    // This Web API call is performed without a bearer token as user won't yet be authenticated
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };

  /**
   * Get registration settings including release mode flag
   * @return {Promise}
   */
  self.getRegistrationSettings = function () {

    var resourceUrl = resourceBaseUrl + '/registrationSettings';
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };

  /**
   * Get reset password settings including release mode flag
   * @return {Promise}
   */
  self.getResetPasswordSettings = function () {

    var resourceUrl = resourceBaseUrl + '/resetPasswordSettings';
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };

  /**
   * Get portal settings including upload url and in release mode flag
   * @return {Promise}
   */
  self.getPortalSettings = function () {

    var resourceUrl = resourceBaseUrl + '/portalSettings';
    return repositoryHelper.ajaxGet(resourceUrl);
  };

  /**
   * Get privacy policy settings including release mode flag
   * @return {Promise}
   */
  self.getPrivacyPolicySettings = function () {

    var resourceUrl = resourceBaseUrl + '/privacyPolicySettings';
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };
}

export default new SystemSettingsRepository();
